import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Calculators", href: "#calculators" },
  { label: "Why Globus", href: "#manifesto" },
  { label: "Our Team", href: "/team" },
  { label: "Contact", href: "#enquire" },
  { label: "Insights", href: "/insights" },
  { label: "Track", href: "/track" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-night/70 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a data-testid="brand-logo" href="#top" className="flex items-center">
          <span className="bg-white rounded-md px-3 py-2 flex items-center shadow-md shadow-black/30">
            <img src="/globus-lockup.png" alt="Globus Financial Services" className="h-8 w-auto object-contain" />
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              href={l.href}
              className="text-sm text-[#A0AAB2] hover:text-gold transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid="nav-enquire-cta"
            href="#enquire"
            className="bg-gold text-night hover:bg-goldhover transition-colors rounded-sm px-5 py-2 text-sm font-semibold flex items-center gap-1"
          >
            Enquire <ArrowUpRight size={14} />
          </a>
        </nav>
        <button
          data-testid="mobile-menu-button"
          aria-label="Toggle menu"
          className="md:hidden text-foreground"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-white/10 bg-night/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-sm text-[#A0AAB2]">
              {l.label}
            </a>
          ))}
          <a
            href="#enquire"
            onClick={() => setOpen(false)}
            className="bg-gold text-night rounded-sm px-5 py-2.5 text-sm font-semibold w-max"
          >
            Enquire
          </a>
        </div>
      )}
    </header>
  );
};
